import Header from "../components/Header";
import Leaderboard from "../components/Leaderboard";
import styled from "styled-components";
import {Link} from "react-router-dom";

const Container = styled.div`
    color: white;
    font-family: 'Inter', sans-serif;
    text-align: center;
    max-width: 800px;
    margin: 0 auto;
    
    line-height: 2;
    
    li {
        margin-bottom: 10px;
    }

    h2 {
        text-transform: uppercase;
        color: #d2a83a;
        font-size: 32pt;
        text-align: center;
    }
    
    a {
        font-size: 14pt;
        display: block;
        color: white;
    }
`;

export default function GroupMeIndex() {
    return (
        <>
            <Header />

            <Container>
                <h2>INDEX</h2>
                <p>
                    This is an index of all the Navigator GroupMe channels. If you are in a public Navs GroupMe and
                    do not see it on this list, send me (Max Goddard) a message to have it added!
                </p>
                <a href="https://groupme.com/join_group/87846416/7I3JgzkX">Main Navs</a>
                <a href="https://groupme.com/join_group/106887692/7ERwYOEh">Study Table</a>
                <a href="https://groupme.com/join_group/110250446/A8km2Mrr">Nav Snipes</a>
                <a href="https://groupme.com/join_group/97558199/1bWFYbLh">Sports Navs</a>
                <a href="https://groupme.com/join_group/109886171/Ayi2jHw6">Kingdom Kickoff</a>
                <a href="https://groupme.com/join_group/102152536/8iVSdqXV">EXTAWGs</a>
                <a href="https://groupme.com/join_group/109414024/yKFSvvu3">Navs Intramurals</a>
                <a href="https://groupme.com/join_group/93166679/yhArxMmz">Hiking</a>
            </Container>
        </>
    );
}